<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.newsTitle" placeholder="请输入资讯标题"></el-input>
				</el-form-item>	
				<el-form-item>
					<el-select v-model="secah.newsStatus" placeholder="请选择状态" clearable>
					    <el-option label="上线" :value="1"></el-option>
						 <el-option label="下线" :value="2"></el-option>
					  </el-select>
				</el-form-item>
				
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="newsTitle" label="标题" align="center">
				</el-table-column>
				<el-table-column prop="newsStatus" label="状态" align="center">
					<template slot-scope="scope">
						{{scope.row.newsStatus==1?"上线":"下线"}}
					</template>
				</el-table-column>	
				<el-table-column prop="newsStatus" label="日期" align="center">
					<template slot-scope="scope">
						{{scope.row.createDate.substring(0,10)}}
					</template>
				</el-table-column>								
				<el-table-column fixed="right" label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'"
			:visible.sync="dialogVisible" :modal-append-to-body='false' width="800px">
			<el-form :model="form">
				<el-form-item label="资讯标题" label-width='100px'>
					<el-input v-model="form.newsTitle"  autocomplete="off" placeholder="请输入标题"></el-input>
				</el-form-item>
				
				
				<el-form-item  label="资讯状态" label-width='100px'>
					<el-select v-model="form.newsStatus" placeholder="请选择状态" clearable>
					    <el-option label="上线" :value="1"></el-option>
						 <el-option label="下线" :value="2"></el-option>
					  </el-select>
				</el-form-item>
				
				<el-form-item label="资讯封面" label-width='100px'>
					<el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'"
						:headers="headers" 
						accept=".png,.jpg"
						:on-error='onError'
						:show-file-list="false" :on-success="handleAvatarSuccess">
						<img v-if="form.newsCover" :src="webUrl+form.newsCover" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<!-- <el-input v-model="form.sort"  autocomplete="off" ></el-input> -->
					<div style="color: red;">请上传67:41的图片比例</div>
				</el-form-item>
				<div data-v-eee9d61e="" class="el-form-item"><label class="el-form-item__label"
						style="width: 100px;">资讯内容</label>
					<div  style="margin-left: 100px;">
						<quill-editor ref="text" v-model="form.newsContent" class="myQuillEditor" :options="editorOption" />
					</div>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		quillEditor
	} from 'vue-quill-editor'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import quillConfig from '../goods/components/quill-config.js'
	export default {
		components: {
			quillEditor
		},
		data() {
			return {
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				webUrl: this.webUrl,
				editorOption: quillConfig,
				headers:{
					'token':this.$store.state.token,
					// 'Content-Type': 'multipart/form-data'
				},
				secah: {
					pageSize: 10,
					pageNum: 1,
					newsStatus:"",
					newsTitle:""
				},
				form: {
						"newsContent": "",//新闻内容
						"newsCover": "",//新闻封面
						"newsStatus": 1,//新闻状态1已上线2未上线
						"newsTitle": "",//新闻标题
						"newsType": 1
				},

			}
		},
		created() {
			this.getlist()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getlist()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form = {
					"newsContent": "",//新闻内容
					"newsCover": "",//新闻封面
					"newsStatus": 1,//新闻状态1已上线2未上线
					"newsTitle": "",//新闻标题
					"newsType": 1
				}
			},
			//提交
			sub() {
				if(this.form.newsTitle.length == 0){
					this.$message('请输入标题');
					return false
				}
				if(this.form.newsCover.length == 0){
					this.$message('请上传封面');
					return false
				}
				// if(this.form.newsTitle.length == 0){
				// 	this.$message('请输入标题');
				// 	return false
				// }
				var url=this.isAdd?"/news/add":"/news/update"
				if (this.isAdd) {
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getlist()
						}
					})
				} else {
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getlist()
						}
					})
				}

			},

			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/news/del?" + this.$qs.stringify({
						newsId: row.newsId
					})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getlist()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form = JSON.parse(JSON.stringify(row))

			},
			//上传封面图片回调
			handleAvatarSuccess(res, file) {
				this.form.newsCover = res.data.path
			},
			
			onError(){
				this.$message.error("上传失败")
			},

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getlist()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getlist()
			},
			//获取数据
			getlist() {
				this.httpPost("/news/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						console.log(res)
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},


		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		border: 1px solid #d9d9d9 !important;
		line-height: 178px !important;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
